/**
 * @Author: WangZhuang@baidu.com
 * @Date: 2023-01-10 17:48:54
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-06-09 16:02:35
 * @FilePath: /m-anquan-baidu-com/src/containers/product/pageUrlSec.js
 * @Description: 网址安全检测
 */
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import ProBanner from '../../components/ProBanner';
import ProductTitle from '../../components/ProductTitle';
import {fetchGetServices, fetchBsbCheck} from '../../actions/productAction';
import {fetchInstanceGetInstance} from '../../actions/buyAction';
import './pageUrlSec.less';
import {bAntiBotSend} from '../../util';

class PageUrlSec extends PureComponent {
    static propTypes = {
        bannerInfo: PropTypes.object,
        fetchBsbCheck: PropTypes.func,
        fetchInstanceGetInstance: PropTypes.func,
        fetchGetServices: PropTypes.func
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            serverData: [],
            resObj: {},
            error: false,
            resRrl: '',
            inputVal: ''
        };
    }

    componentDidMount() {
        this.props.fetchInstanceGetInstance().then(data => {
            let json = {};
            if (data.data.status === 0) {
                json['instance_id'] = Object.keys(data.data.data)[0];
            }

            this.props.fetchGetServices(json).then(data => {
                if (data.status === 0) {
                    this.setState({
                        serverData: data.data
                    });
                }
            });
        });

    }

    checkFn = () => {
        let {inputVal} = this.state;
        let newVal = '';
        if (!inputVal) {
            this.setState({
                error: '请输入要查询的网址'
            });
            return false;
        }

        if (!/^https?:/.test(inputVal)) {
            newVal = 'http://' + inputVal;
            this.setState({
                inputVal: newVal
            });
        } else {
            newVal = inputVal;
        }

        if (!/https?:\/\/[A-Za-z0-9_-]+\.[A-Za-z0-9]+/.test(newVal)) {
            this.setState({
                error: '输入的域名不符合规范，请确认输入域名的准确性'
            });
            return;
        }

        this.setState({
            error: false
        });
        bAntiBotSend();
        if (window['__abbaidu_2024_cb']) {
            window['__abbaidu_2024_cb'] = async responseData => {
                let companyJson = {
                    url: newVal
                };

                let localData = JSON.parse(responseData);
                if (localData && localData.data) {
                    companyJson.data = localData.data;
                }
                if (localData && localData.key_id) {
                    companyJson['key_id'] = localData['key_id'];
                }
                if (localData && localData.sign) {
                    companyJson.sign = localData.sign;
                }
                this.props.fetchBsbCheck(companyJson).then(data => {
                    if (data.status === 0) {
                        this.setState({
                            resObj: data.data,
                            resRrl: newVal
                        });
                    } else if (data.status === 401) {
                        window.location.href = this.loginUrl();
                    } else {
                        this.setState({
                            error: data.description
                        });
                    }
                });
            };
        } else {
            setTimeout(() => {
                this.checkFn();
            }, 300);
        }

    };

    handleTime = item => {
        let buyType = this.state.buyType;
        let val = item < 31536000 ? parseInt(item / 2592000, 10) : parseInt(item / 31536000, 10);
        let unit = item < 31536000 ? <span><span>月</span>
            {buyType === 'ent' && item >= 31536000 ? <i>(3折)</i> : null}</span> : '年';
        return <div>
            {val}
            {/* {buyTime === item || item >= 31536000 ? unit : null} */}
            {unit}
        </div>;
    };

    denderRes = () => {
        let {resObj, resRrl} = this.state;
        let imgUrl = '';
        let imgName = '';
        switch (resObj.score) {
            case '白':
            case '灰':
                imgName = '安全';
                imgUrl = 'anquan';
                break;
            case '未知':
                imgName = '未知';
                imgUrl = 'weizhi';
                break;
            default:
                imgName = '危险';
                imgUrl = 'weixian';
                break;
        }
        return <div className={'res'}>
            <div className={'title'}>网址检测结果</div>
            <div className={'img'}>
                <img src={require(`../../asset/image/pageUrlSec/icon_${imgUrl}.svg`)} alt=""/>
                <span className={imgUrl}>{imgName}</span>
            </div>
            <div className={'text'}>
                <div>检测地址</div>
                <div>{resRrl}</div>
            </div>
        </div>;
    };

    render() {
        const bannerInfo = this.props.bannerInfo || {};
        // let {serverData, inputVal, resObj, error} = this.state;

        /* bca-disable */
        return (
            <div className={'product pageUrlSec'}>
                <div className="pro-banner-box bg-new">
                    <ProBanner
                        title={bannerInfo.title}
                        urlText={bannerInfo.urlText}
                        bgImg={bannerInfo.bgImg}
                        url={bannerInfo.url}
                    />
                    {bannerInfo.nextText ? (
                        <a href={bannerInfo.nextUrl} target="_blank" className="compliance-btn">
                            {bannerInfo.nextText}
                        </a>
                    ) : null}
                </div>

                <div className={'product-des'}>
                    {bannerInfo.bannerNote}
                </div>

                {/* <div className={'product-mod'}>
                    <ProductTitle title={'在线试用'}/>
                </div> */}

                {/* <div className={'search-box'}>
                    <div className={'search-mod'}>
                        <form
                            onSubmit={ev => {
                                this.checkFn();
                                ev.preventDefault();
                            }}
                            action={'#'}
                        >
                            <input
                                type="search"
                                className={'search'}
                                placeholder="请输入要查询的网址"
                                value={inputVal}
                                onChange={ev => {
                                    this.setState({
                                        inputVal: ev.target.value
                                    });
                                }}
                            />
                            {
                                inputVal
                                    ? <i
                                        className={'clear'}
                                        onClick={() => {
                                            this.setState({
                                                inputVal: ''
                                            });
                                        }}
                                    />
                                    : null
                            }

                        </form>
                    </div>

                    {
                        error ? <div className={'error'}>{error}</div> : null
                    }

                    {
                        resObj.score
                            ? <div className={'res-box'}>{this.denderRes()}</div>
                            : null
                    }
                </div> */}

                {/* <div className={'bgf5'}>
                    <div className={'product-mod'}>
                        <ProductTitle title={'购买套餐'}/>
                    </div>
                    <div className={'server-mod'}>
                        {
                            serverData.map((item, index) => {
                                if (item.version === 'free' && item.is_buy === 1) {
                                    // 已购买不展示
                                    return null;
                                }
                                return <div className={'list'} key={index}>
                                    <div className={'top'}>
                                        <div>{item.meal_name}</div>
                                        {
                                            item.price[0].toString() === '0'
                                                ? <div>
                                                    免费
                                                </div>
                                                : <div>
                                                    {item.price[0]}<span>元</span>
                                                </div>
                                        }

                                    </div>
                                    <div className={'center'}>
                                        <div dangerouslySetInnerHTML={{__html: item.service_desc}}>
                                        </div>
                                        <div>
                                            <div>有效期</div>
                                            <div>{this.handleTime(item.time[0])}</div>
                                        </div>
                                    </div>
                                    <a
                                        href={'/console/#/urlsec/buy/' + item.meal_id}
                                        target={'_blank'}
                                        className={'m-btn'}
                                    >
                                        {
                                            item.price[0].toString() === '0' ? '免费开通' : '购买'
                                        }
                                    </a>
                                </div>;
                            })
                        }
                    </div>
                </div> */}

                <div className={'product-mod mt100'}>
                    <ProductTitle title={'产品优势'}/>
                </div>

                <div className={'product-mod'}>

                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/pageUrlSec/jiance.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>系统检测能力强</div>
                            <div className={'proinfo-box-des'}>
                                基于百度大数据和人工智能技术，日均检测URL超过3亿条
                            </div>
                        </div>
                    </div>
                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/pageUrlSec/jianchu.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>检出能力强</div>
                            <div className={'proinfo-box-des'}>
                                日均检出威胁URL超过600万，检测准确率高99%+、检出率95%+
                            </div>
                        </div>
                    </div>
                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/pageUrlSec/duiwai.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>对外服务能力强</div>
                            <div className={'proinfo-box-des'}>
                                日均安全查询超过30亿，平均响应时间为30毫秒，系统服务稳定99.99%
                            </div>
                        </div>
                    </div>
                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/pageUrlSec/zhichi.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>支持多种检测模型</div>
                            <div className={'proinfo-box-des'}>
                                支持DNN等多种检测模型算法，结合产品需求灵活定制防护能力
                            </div>
                        </div>
                    </div>
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title={'适用场景'}/>
                </div>

                <div className={'product-mod'}>
                    <div
                        className={'pro-applicable'}
                        style={{backgroundImage: `url(${require('../../asset/image/pageUrlSec/1-wap.png')})`}}
                    >
                        <div className={'pro-app-title'}>
                            欺诈场景
                        </div>
                        <div className={'pro-app-content'}>
                            虚假中奖、虚假登录、虚假购物、虚假招聘、虚假客服
                        </div>
                    </div>

                    <div
                        className={'pro-applicable'}
                        style={{backgroundImage: `url(${require('../../asset/image/pageUrlSec/2-wap.png')})`}}
                    >
                        <div className={'pro-app-title'}>
                            隐私保护场景
                        </div>
                        <div className={'pro-app-content'}>
                            个人隐私信息如身份证、银行卡等证件信息，基本资料及手机号，网购历史数据、酒旅信息、健康情况等
                        </div>
                    </div>

                    <div
                        className={'pro-applicable'}
                        style={{backgroundImage: `url(${require('../../asset/image/pageUrlSec/3-wap.png')})`}}
                    >
                        <div className={'pro-app-title'}>
                            风险场景
                        </div>
                        <div className={'pro-app-content'}>
                            钓鱼网站、恶意跳转、网页挂码、网站被黑
                        </div>
                    </div>

                    <div
                        className={'pro-applicable'}
                        style={{backgroundImage: `url(${require('../../asset/image/pageUrlSec/4-wap.png')})`}}
                    >
                        <div className={'pro-app-title'}>
                            违法场景
                        </div>
                        <div className={'pro-app-content'}>
                            利用网站内容审核漏洞发布博彩、色情、非法言论等违法信息，滥用网络基础设施，篡改高权重网站页面
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        fetchBsbCheck: obj => fetchBsbCheck(obj),
        fetchGetServices: json => fetchGetServices(json),
        fetchInstanceGetInstance: () => fetchInstanceGetInstance(dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PageUrlSec);



// WEBPACK FOOTER //
// ./src/containers/product/pageUrlSec.js